// extracted by mini-css-extract-plugin
export default {"pop":"index__pop__kvLQS","settingOutlined":"index__settingOutlined__YsvLN","title":"index__title__cQpkM"};